exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity[data-v-36f2f7ea] {\n  padding-left: 0px;\n}\n\n/*.quantity-type {\r\n    text-transform: lowercase;\r\n}\r\n.quantity-type:first-letter {\r\n    text-transform: capitalize;\r\n}*/\n", ""]);

// exports
